import React, { useState, useContext, useRef} from "react";
import http from "./http-common";
import {TokenContext} from "../../src/components/Store";

import {trackPromise} from "react-promise-tracker";
import {List, ListItem} from "@mui/material";
import ObjecttypeSelectlist from "./ObjecttypeSelectlist";
import MaterialTable from "@material-table/core";
import SaveIcon from "@mui/icons-material/Save";

import {header} from './headerStyle';
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";


const styles = {
    itemWidth100: {
        width: '100%',
    },
    right: {
        verticalAlign: 'right'
    }
};

const GetObjectDataByType = async (objecttype, type, theRealm, token) => {
    try {
        let formData = new FormData();
        formData.append("realm", theRealm);
        return await http.post(`/` + objecttype + `/` + type + `/list`, formData, {
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};

function ObjectsSelection({realm, setSelectedObjects, setShowTable}) {
    const [token] = useContext(TokenContext);
    const [isLoading, setIsLoading] = useState(false);
    const [dataObjects, setDataObjects] = useState([]);
    const tableRef = useRef();

    const options = [
        {value: '', text: '-- Bitte wählen Sie einen Objekttypen --'},
        {value: 'site', text: 'Liegenschaft'},
        {value: 'structure', text: 'Bauwerk'},
        {value: 'building', text: 'Gebäude'},
        {value: 'storey', text: 'Geschoß'},
        {value: 'room', text: 'Raum'},
        {value: 'playground', text: 'Spielplatz'},
    ];

    const [selected, setSelected] = useState(options[0].value);
    const [title, setTitle] = useState('Bitte wählen Sie einen Objekttypen');
    const [fieldType, setFieldType] = useState('administrativeobjectType');

    const handleObjecttypeChange = async(objecttype, type) => {
        setIsLoading(true);
        try {
            await trackPromise((async () => {
                const bla = await GetObjectDataByType(objecttype, type, realm, token);
                setDataObjects(bla.data);
            })());
        } catch (e) {
            console.error(e);
        } finally {
            setIsLoading(false);
        }
    };

    const handleChange = async(event) => {
        setSelected(event.target.value);
        let objecttype, type;
        switch (event.target.value) {
            case 'site':
                objecttype = 'realestateobject';
                type = 'site';
                setTitle('Liegenschaften');
                setFieldType('realestateobjectType');
                break;
            case 'structure':
                objecttype = 'realestateobject';
                type = 'structure';
                setTitle('Bauwerke');
                setFieldType('realestateobjectType');
                break;
            case 'building':
                objecttype = 'realestateobject';
                type = 'building';
                setTitle('Gebäude');
                setFieldType('realestateobjectType');
                break;
            case 'room':
                objecttype = 'realestateobject';
                type = 'room';
                setTitle('Räume');
                setFieldType('realestateobjectType');
                break;
            case 'storey':
                objecttype = 'realestateobject';
                type = 'storey';
                setTitle('Etagen');
                setFieldType('realestateobjectType');
                break;
            case 'playground':
                objecttype = 'realestateobject';
                type = 'playground';
                setTitle('Spielplätze');
                setFieldType('realestateobjectType');
                break;
            case 'wastecollectionpoint':
                objecttype = 'realestateobject';
                type = 'wastecollectionpoint';
                setTitle('Müllstandplatz');
                setFieldType('realestateobjectType');
                break;
            case 'economicunit':
                objecttype = 'administrativeobject';
                type = 'economicunit';
                setTitle('Wirtschafteinheiten');
                setFieldType('administrativeobjectType');
                break;
            case 'apartment':
                objecttype = 'administrativeobject';
                type = 'apartment';
                setTitle('Wohnungen');
                setFieldType('administrativeobjectType');
                break;
            case 'rentalunit':
                objecttype = 'administrativeobject';
                type = 'rentalunit';
                setTitle('Mieteinheiten');
                setFieldType('administrativeobjectType');
                break;
            case 'commercialunit':
                objecttype = 'administrativeobject';
                type = 'commercialunit';
                setTitle('Gewerbeeinheiten');
                setFieldType('administrativeobjectType');
                break;
            case 'parkingspace':
                objecttype = 'administrativeobject';
                type = 'parkingspace';
                setTitle('Stellplatzanlagen');
                setFieldType('administrativeobjectType');
                break;
            case 'location':
            // intentional fallthrough
            case 'buildingentrance':
                objecttype = 'administrativeobject';
                type = 'buildingentrance';
                setTitle('Hauseingänge');
                setFieldType('administrativeobjectType');
                break;
            case 'parcel':
                objecttype = 'administrativeobject';
                type = 'parcel';
                setTitle('Flurstücke');
                setFieldType('administrativeobjectType');
                break;
            case 'territorialdivision':
                objecttype = 'administrativeobject';
                type = 'territorialdivision';
                setTitle('Gebietsgliederungen');
                setFieldType('administrativeobjectType');
                break;
            case 'washhouse':
                objecttype = 'administrativeobject';
                type = 'washhouse';
                setTitle('Waschhäuser');
                setFieldType('administrativeobjectType');
                break;
            default:
                objecttype = 'administrativeobject';
                type = 'economicunit';
                setTitle('Wirtschaftseinheiten');
                setFieldType('administrativeobjectType');
        }

        await handleObjecttypeChange(objecttype, type);
    };

    const handleAssignClick = async(object, event) => {
        event.preventDefault();
        setIsLoading(true);
        const objects = object.map(obj => obj.guid);
        setSelectedObjects(objects);
        setShowTable(false);
        setIsLoading(false);
    };

    const tableHeight = ((window.innerHeight - 280) * .75) / (window.innerHeight) * 100;

    return (
        <>
            <div
                style={{
                    width: "75vw",
                    height: "75vh",
                    display: "block",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex:999,
                    position: "absolute",
                    top: "15vh",
                    left: "20vw",
                    backgroundColor: "transparent",
                    borderTop: "1px solid #adadad",
                    borderLeft: "1px solid #adadad",
                    borderRight: "1px solid #adadad",
                }}
            >
            <List style={{backgroundColor: "#FFFFFF"}} sx={styles.itemWidth100}>
                <ListItem sx={styles.itemWidth100}>
                    <ObjecttypeSelectlist
                        options={options}
                        selected={selected}
                        handleChange={handleChange}
                    />
                    <IconButton
                        edge="end"
                        color="inherit"
                        onClick={() => setShowTable(false)}
                        aria-label="close"
                        style={{ position: "absolute", top: "10px", right: "15px" }}
                    >
                        <CloseIcon />
                    </IconButton>
                </ListItem>
            </List>
            <MaterialTable
                tableRef={tableRef}
                title={title}
                columns={[
                    { title: 'Bezeichnung', field: 'name' },
                    { title: 'Nummer', field: 'number'},
                    { title: 'Kennzeichen', field: 'label' },
                    { title: 'Typ', field: fieldType},
                ]}
                data={dataObjects}

                options={{
                    headerStyle: header,
                    rowStyle: rowData => ({
                        backgroundColor: (rowData.deactivated) ? '#EEE' : '#FFF'
                    }),
                    pageSize: 10,
                    pageSizeOptions: [10, 20, 50, 100],
                    actionsColumnIndex: -1,
                    selection: true,
                    exportButton: true,
                    exportAllData: true,
                    maxBodyHeight: `${tableHeight}vh`,
                    minBodyHeight: `${tableHeight}vh`,
                }}

                isLoading={isLoading}
                localization={{
                    pagination: {
                        labelDisplayedRows: '{from}-{to} von {count}',
                        labelRowsSelect: 'Zeilen',
                        labelRowsPerPage: 'Zeilen pro Seite'
                    },
                    toolbar: {
                        nRowsSelected: '{0} Zeile(n) ausgewählt',
                        searchTooltip: 'Suchen',
                        searchPlaceholder: 'Suchbegriff eingeben'
                    },
                    header: {
                        actions: 'zuweisen'
                    },
                    body: {
                        emptyDataSourceMessage: 'Keine Einträge gefunden',
                        filterRow: {
                            filterTooltip: 'Filter'
                        }
                    }
                }}
                onRowClick={(event, rowData) => {
                    const rowDataCopy = { ...rowData };
                    rowDataCopy.tableData.checked = !rowDataCopy.tableData.checked;
                    const dataCopy = [...dataObjects];
                    dataCopy[rowDataCopy.tableData.id] = rowDataCopy;
                    setDataObjects(dataCopy);
                }}
                actions={[
                    rowData => ({
                        icon: () => <SaveIcon />,
                        tooltip: 'dem Projekt zuweisen',
                        onClick: (event, rowData) => handleAssignClick(rowData, event)
                    }),
                ]}
                />
            </div>
        </>
    )
}

export default ObjectsSelection;
